import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as rentMachineCategoryActions from '../../../actions/rent-machine/rentMachineCategoryActions';
import * as spinnerActions from '../../../actions/spinnerActions';
import * as modalActions from '../../../actions/common/modalActions';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router-dom';
import MediaQuery from 'react-responsive';
import CustomModal from '../../../components/CustomModal';
import {toastr} from 'react-redux-toastr';
import BaseList from '../../../components/common/list/BaseList.jsx';
import { injectIntl } from 'react-intl';
import WithResolvedPromises from "../../common/WithResolvedPromises";
import PlaceholderError from "../../common/PlaceholderError";
import PlaceholderTable from "../../common/PlaceholderTable";
import CategoryListDivs from "./CategoryListDivs";
import CategoryList from "./CategoryList";

class CategoryPage extends BaseList {
    constructor(props) {
        super(props);
        this.listId = 'rent-machine-categories';
        this.idToDelete = null;

        this.state = {
            showDeleteModal: false,
            actions: this.getRequiredActions()
        };

        this.onDelete = this.onDelete.bind(this);
    }

    getRequiredActions() {
        return [
            this.props.actions.getRentMachineCategories()
        ]
    }

    onDelete(id) {
        this.idToDelete = id;
        this.props.actions.showModal();
    }

    confirmDelete() {
        if (this.idToDelete !== null) {
            this.props.actions.deleteRentMachineCategory(this.idToDelete)
                .then(() => {
                    this.idToDelete = null;
                    this.props.actions.getRentMachineCategories();
                    this.props.actions.hideModal();
                    toastr.success('Kategori blev slettet');
                });
        } else {
            toastr.error('En kategori kan ikke slettes');
            this.props.actions.hideModal();
        }
    }

    hideDeleteModal() {
        this.idToDelete = null;
        this.props.actions.hideModal();
    }

    render() {
        return (
            <WithResolvedPromises
                promises={this.state.actions}
                preloaderComponent={PlaceholderTable}
                errorComponent={PlaceholderError}>
                {
                    addActions => {
                        return(
                            <div>

                                <CustomModal
                                    modalTitle={'Er du sikker på, at du vil slette denne kategori?'}
                                    modalContent={<p>Er du sikker på, at du vil slette denne kategori?</p>}
                                    confirmText={'Ja'}
                                    closeText={'Nej'}
                                    handleConfirm={() => {this.confirmDelete()}}
                                />

                                <div className="row">
                                    <div className="col-12">
                                        <div className="card m-b-20">
                                            <div className="card-block">
                                                <div className='row'>
                                                    <div className="col-sm-6">
                                                        <h1 className="mb-3">Udlejningskategorier</h1>
                                                    </div>
                                                    <div className="col-sm-6 pt-2">
                                                        <Link
                                                            to="/rent/kategorier/rediger"
                                                            className="btn btn-primary waves-effect pull-right"
                                                        >
                                                            Skab
                                                        </Link>
                                                    </div>
                                                </div>
                                                <MediaQuery query='(max-device-width: 768px)'>
                                                    <CategoryListDivs
                                                        categories={this.props.rentMachineCategories}
                                                        onDelete={this.onDelete}
                                                    />
                                                </MediaQuery>
                                                <MediaQuery query='(min-device-width: 769px)'>
                                                    <CategoryList
                                                        categories={this.props.rentMachineCategories}
                                                        onDelete={this.onDelete}
                                                        listId={this.listId}
                                                    />
                                                </MediaQuery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                }
            </WithResolvedPromises>

        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        rentMachineCategories: state.rentMachineCategories,
        showDeleteModal: state.showModal
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...rentMachineCategoryActions,
            ...spinnerActions,
            ...modalActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CategoryPage));


// WEBPACK FOOTER //
// ./web/src/components/rent-machine/category/CategoryPage.jsx